module.exports = __webpack_public_path__ + "img/account-welcome-background.a580e308.jpg";